// ABOUTME: Hook to evaluate calculated fields for a node via the JSONata evaluate-calculated-fields API.
// ABOUTME: Returns calculated field results and provides a trigger function for re-evaluation.

import { useCallback, useState } from 'react';

export interface CalculatedFieldResult {
    contentTypeGroup: string;
    contentType: string;
    value: Record<string, string>;
}

interface ContentEntry {
    contentTypeGroup: string;
    contentTypeGroupIndex: number;
    contentType: string;
    repeatable: boolean;
    type: string;
    value: Array<Record<string, unknown>>;
}

interface EvaluateResponse {
    success: boolean;
    calculatedFields: CalculatedFieldResult[];
    errors: string[];
}

/**
 * Calls POST /api/jsonata/evaluate-calculated-fields and returns the results.
 * Returns empty array on error for graceful degradation.
 */
export function useCalculatedFields() {
    const [calculatedFields, setCalculatedFields] = useState<CalculatedFieldResult[]>([]);
    const [loading, setLoading] = useState(false);

    const evaluateCalculatedFields = useCallback(
        async (hierarchyId: string, nodeId: string, contents: ContentEntry[]) => {
            setLoading(true);
            try {
                const response = await fetch('/api/jsonata/evaluate-calculated-fields', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ hierarchyId, nodeId, contents }),
                });
                const data: EvaluateResponse = await response.json();
                const fields = data.calculatedFields ?? [];
                setCalculatedFields(fields);
                return fields;
            } catch {
                setCalculatedFields([]);
                return [];
            } finally {
                setLoading(false);
            }
        },
        [],
    );

    return { calculatedFields, loading, evaluateCalculatedFields };
}
